module.exports = __webpack_public_path__ + "static/img/smartstation43.81e89a0a.png";